import $ from "jquery";
import util from "../util";
import History from "./history";
import {addComponent} from "./component";
import {setPrimaryColor} from "./colors";
import Renderer from "./renderer";
import store from "../store";
import * as actions from "../actions";
import {handlePixabayUpload, handlePixabayVideoUpload} from "./pixabay-upload";
import Interactable from "./interactable";

function getTemplateImageSrc($image) {
    let src = $image.attr('data-path-original');
    if (!!src) {
        return src;
    }

    if ($image.attr('data-original-bg-img')) {
        return $image.attr('data-original-bg-img');
    }

    const preview = $image.attr('data-preview');
    return $image.find('img').attr('src') ? $image.find('img').attr('src') : preview;
}

function getTemplateVideoSrc($video) {
    let src = $video.attr('data-path-original');
    if (!!src) {
        return src;
    }

    if ($video.attr('data-original-bg-video')) {
        return $video.attr('data-original-bg-video');
    }

    const preview = $video.attr('data-preview');
    return $video.find('video').attr('src') ? $video.find('video').attr('src') : preview;
}

let suggestedFrames = [];
function clearSuggestedFrames() {
    if (suggestedFrames.length > 0) {
        suggestedFrames.forEach(($frame) => {
            if (util.isFrame($frame)) {
                const $frameImg = $frame.find('.img');
                $frameImg.css('background-image', $frameImg.attr('data-original-bg-img'));
            } else if (util.isQrCode($frame)) {
                const $qrImg = $frame.find('img');
                $qrImg.attr('src', $qrImg.attr('data-original-bg-img'));
            }
        });
        suggestedFrames = [];
    }
}

export function onTemplatePreMove(event) {
    const { interaction } = event;
    if (interaction.pointerIsDown && !interaction.interacting() && !Interactable.isInteracting()) {
        const clone = event.currentTarget.cloneNode(true);
        const x = event.clientX - 25;
        const y = event.clientY - 25;

        clone.style.position = '';
        clone.style.top = '';
        clone.style.left = '';

        clone.setAttribute('id', 'moving-component');
        clone.style.webkitTransform = `translate(${x}px, ${y}px)`;
        clone.style.transform = `translate(${x}px, ${y}px)`;

        clone.setAttribute('data-x', x);
        clone.setAttribute('data-y', y);

        if (clone.classList.contains('saved-qr-code')) {
            clone.removeChild(clone.getElementsByClassName('dropdown')[0]);
            clone.removeChild(clone.getElementsByClassName('label')[0]);
        }


        if (clone.getAttribute('data-component') === 'frame') {
            if (clone.firstChild.getElementsByClassName('author-info').length > 0) {
                clone.firstChild.removeChild(clone.firstChild.getElementsByClassName('author-info')[0]);
            }
            if (clone.firstChild.getElementsByClassName('video-info').length > 0) {
                clone.firstChild.removeChild(clone.firstChild.getElementsByClassName('video-info')[0]);
            }
            if (event.currentTarget.firstChild.getAttribute('data-pixabay-info')) {
                clone.setAttribute('data-pixabay-info', event.currentTarget.firstChild.getAttribute('data-pixabay-info'));
            }
        }

        document.body.appendChild(clone);

        interaction.start({ name: 'drag' }, event.interactable, clone);
    }
}

let prevDrop = null;

export const onTemplateMove = function (event) {
    const { target } = event;
    const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
    const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

    target.style.webkitTransform = `translate(${x}px, ${y}px)`;
    target.style.transform = `translate(${x}px, ${y}px)`;

    target.setAttribute('data-x', x);
    target.setAttribute('data-y', y);

    if (event.dropzone) {
        const $drop = $(event._interaction.dropState.cur.element);
        if (!$drop.hasClass('template') && !$drop.parent().hasClass('template')) {
            if (util.isFrame($drop) && !util.isVideoFrame($(target))) {
                if (!$drop.is(prevDrop)) {
                    clearSuggestedFrames();
                }
                prevDrop = $drop;

                const $target = $(target);
                const $kid = $target.children(':first');
                if (util.isImage($kid) || (util.isFrame($kid) && !$kid.find('.img').css('background-image').includes('img-plc'))) {
                    const $image = $target.find('.image').length > 0 ? $target.find('.image') : $target.find('div.img');
                    const src = getTemplateImageSrc($image);
                    const $frameImg = $drop.find('.img');

                    if (!$frameImg.css('background-image').includes(src)) {
                        $frameImg.attr('data-original-bg-img', $frameImg.css('background-image'));
                        $frameImg.css('background-image', `url('${src}')`);
                        suggestedFrames.push($drop);
                    }
                }
            } else {
                clearSuggestedFrames();
                if (util.isQrCode($drop)) {
                const $target = $(target);
                    if ($target.hasClass('saved-qr-code')) {
                        const src = $target.find('img').attr('src');
                        const $qrFrame = $drop.find('img');
                        $qrFrame.attr('data-original-bg-img', $qrFrame.attr('src'));
                        $qrFrame.attr('src', src);
                        suggestedFrames.push($drop);
                    }
                }
            }
        }
    }
};

export function onTemplateDropped(event) {
    event.stopPropagation();
    const { target } = event;
    target.style.webkitTransform = 'translate(0)';
    target.style.transform = 'translate(0)';
    target.removeAttribute('data-x');
    target.removeAttribute('data-y');

    clearSuggestedFrames();
    if (event.dropzone) {
        let $drop = $(event._interaction.dropState.cur.element);
        if (!$drop.hasClass('template') && !$drop.parent().hasClass('template')) {
            const $target = $(target);
            if (util.isFrame($drop) && (util.isImage($target) || (util.isFrame($target) && !$target.find('div.img').css('background-image').includes('img-plc')))) {
                addPhotoToFrame($drop, $target);
            } else if (util.isFrame($drop) && util.isVideoFrame($drop) && (util.isVideoFrame($target))) {
                addVideoToFrame($drop, $target);
            } else if (util.isQrCode($drop) && $target.hasClass('saved-qr-code')) {
                let qrLink = $target.find('img').attr('src');
                Renderer.addQrToFrame($drop, qrLink);
                util.nextTick(() => {
                    Renderer.deselectAll();
                    store.dispatch(actions.deselect());
                    Renderer.select($drop);
                    store.dispatch(actions.select($drop));
                })
            } else {
               let parentId = event._interaction.dropState.cur.element.id;
                if (util.isFrame($drop) || util.isQrCode($drop)) {
                    parentId = $drop.parents('.page').attr('id');
                    $drop = $drop.parents('.page');
                }

                const parentOffsetLeft = $drop.offset().left;
                const parentOffsetTop = $drop.offset().top;
                const parentPositionTop = $drop.position().top;

                addComponent(parentId, target.innerHTML, {
                    position: {
                        left: event.clientX - parentOffsetLeft,
                        top: event.clientY - parentOffsetTop + (window.scrollY > parentOffsetTop ? parentPositionTop : window.scrollY)
                    },
                    styles: {
                    },
                    isFromTemplate: true,
                    textPreset: $target.attr("data-text-preset")
                });
            }
        }
    }

    $(target).parents('.wrap').css('overflow-y', 'auto');
    $(target).remove();
}

export function addPhotoToFrame($drop, $target) {
    let $frameImg = $drop.find('.img');

    if (!$frameImg.length) {
        const newFrameImg = document.createElement('div');
        newFrameImg.classList.add('img');
        newFrameImg.style.width = '100%';
        newFrameImg.style.height = '100%';
        $drop.append(newFrameImg);
        $frameImg = $(newFrameImg);
    } 

    let oldSrc = $frameImg.attr('data-original-bg-img');

    const $image = $target.find('.image').length > 0 ? $target.find('.image') : $target.find('div.img');
    const src = getTemplateImageSrc($image);

    function doAction($frameImg, src, undo, $source=null, $drop=null) {
        if (undo) {
            src = $frameImg.attr('data-original-bg-img');
        }

        let video = $drop.find('.video').get(0);

        if (video) {
            $drop.attr('data-type', 'frame');
            $drop.attr('data-component', 'frame');
            $drop.css('height', window.getComputedStyle($drop.find('.video').get(0)).getPropertyValue("height"));
            $drop.find('.video').get(0).remove();
        } else {
            $frameImg.attr('data-original-bg-img', $frameImg.css('background-image').split('"')[1].split('"')[0]);
        }
        
        $frameImg.css('background-image', `url("${src}")`);
        $frameImg.css('background-size', 'cover');
        $frameImg.css('background-position', 'center center');

        $drop.attr('data-pixabay-info', '');
        $drop.attr('data-id', '');
        $drop.attr('data-asset-id', '');

        if (src.includes('pixabay')) {
            $drop.attr('data-pixabay-info', $source.attr('data-pixabay-info') || $source.find('.frame').attr('data-pixabay-info'));
        }

        if ($source.attr('data-id') || $source.find('.image').attr('data-id')) {
            $drop.attr('data-id', $source.attr('data-id') || $source.find('.image').attr('data-id'));
        }

        if ($source.attr('data-asset-id') || $source.find('.image').attr('data-asset-id')) {
            $drop.attr('data-asset-id', $source.attr('data-asset-id') || $source.find('.image').attr('data-asset-id'));
        }

        if (src.includes('pixabay') && !src.includes('amazon')) {
            let pixabayInfo = $source.attr('data-pixabay-info') || $source.find('.frame').attr('data-pixabay-info');
            pixabayInfo = JSON.parse(pixabayInfo);
            handlePixabayUpload($drop, pixabayInfo, src, false);
            $drop.attr('data-pixabay-info', JSON.stringify(pixabayInfo));
        }

        Interactable.refreshFavorites();
    }

    const redo = () => doAction($frameImg, src, false, $target, $drop);
    const undo = () => doAction($frameImg, oldSrc, true);

    redo();
    History.push(undo, redo, 'Place photo in frame');

    if ($drop.attr('data-full-page')) {
        setPrimaryColor($drop);
    }
}

export function addVideoToFrame($drop, $target) {
    let $frameVideo = $drop.find('.video');

    if (!$frameVideo.length) {
        const newFrameVideo = document.createElement('div');
        newFrameVideo.classList.add('video');
        newFrameVideo.style.width = '100%';
        newFrameVideo.style.height = '100%';
        $drop.append(newFrameVideo);
        $frameVideo = $(newFrameVideo);
    } 

    let oldSrc = $frameVideo.attr('data-original-bg-video');

    const $video = $target.find('.video').length > 0 ? $target.find('.video') : $target.find('div.video');
    const src = getTemplateVideoSrc($video);

    function doAction($frameVideo, src, undo, $source=null, $drop=null) {
        if (undo) {
            src = $frameVideo.attr('data-original-bg-video');
        }
        
        let video = $frameVideo.find('video').get(0);

        if (!video) {
            video = document.createElement('video');
            video.style.width = "100%";
            video.style.height = "100%";
            video.style.objectFit = "cover";
            video.controls = false;
            video.muted = false;
            video.autoplay = true;
            video.loop = true;
            video.controlsList = "noplaybackrate nodownload nofullscreen";
            video.style.borderRadius = $drop.find('.img').css('border-radius');
            
            $drop.find('.img').get(0).remove();
            $drop.attr('data-type', 'video-frame');
            $drop.attr('data-component', 'video-frame');
            $frameVideo.append(video);
        }

        video.src = src;

        $frameVideo.attr('data-original-bg-video', src);

        // Loading spinner
        $frameVideo.addClass("loading");
        $(video).off("loadedmetadata");
        $(video).on("loadedmetadata", function () {
            $(video).parent().removeClass('loading');
        });

        if (src.includes('player.vimeo') && !src.includes('amazon')) {
            let pixabayInfo = $source.attr('data-pixabay-info') || $source.find('.frame').attr('data-pixabay-info');
            pixabayInfo = JSON.parse(pixabayInfo);
            video.poster = pixabayInfo.poster;
            handlePixabayVideoUpload($drop, pixabayInfo, src, false);
        }
    }

    const redo = () => doAction($frameVideo, src, false, $target, $drop);
    const undo = () => doAction($frameVideo, oldSrc, true);

    redo();
    History.push(undo, redo, 'Place video in frame');

    if ($drop.attr('data-full-page')) {
        setPrimaryColor($drop);
    }
}
